import {
  GET_SENTIMENT_WORDCLOUD_WATCHER,
  GET_SENTIMENT_WORDCLOUD_SUCCESS,
  GET_SENTIMENT_WORDCLOUD_FAILED,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
  GET_QUALITATIVE_QUESTIONS_SUCCESS,
  GET_QUALITATIVE_QUESTIONS_FAILED,
} from "./constants"

export function getSentimentWordcloudWatcher(payload) {
  return {
    type: GET_SENTIMENT_WORDCLOUD_WATCHER,
    payload,
  }
}

export function getSentimentWordcloudSuccess(payload) {
  return {
    type: GET_SENTIMENT_WORDCLOUD_SUCCESS,
    payload,
  }
}

export function getSentimentWordcloudFailed() {
  return { type: GET_SENTIMENT_WORDCLOUD_FAILED }
}

export function getQualitativeQuestionsWatcher(payload) {
  return {
    type: GET_QUALITATIVE_QUESTIONS_WATCHER,
    payload,
  }
}

export function getQualitativeQuestionsSuccess(payload) {
  return {
    type: GET_QUALITATIVE_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getQualitativeQuestionsFailed() {
  return { type: GET_QUALITATIVE_QUESTIONS_FAILED }
}
